import { EventBase } from "@vp/models";

export interface DeviceConnectionChangedEventArgs {
  deviceUserId: string;
  isOnline: boolean;
  lastConnectedDateTime: string;
  lastDisconnectedDateTime: string;
  patientConsoleDeviceData: any;
}

export class DeviceConnectionChangedEvent extends EventBase<DeviceConnectionChangedEventArgs> {
  constructor(deviceArgs: DeviceConnectionChangedEventArgs) {
    super();
    this.args = deviceArgs;
  }
}
